import { EventEmitter } from "@angular/core";
import { DealerBranding, DealerBrandingListItem } from "@app/entity/model/dealer-branding";
import { ActionPayloadGeneric } from "@app/root-store/actions";
import {
    createActionSet,
    createCrudActionSets,
    createDeletePromptActionSet,
    createNoPropsAction,
} from "@app/root-store/actions/action-creators";
import { Action } from "@ngrx/store";
import { TypedAction } from "@ngrx/store/src/models";

export enum ActionTypes {
    DealerBrandingZipFileDownload = "DealerBrandingZipFileDownload",
    GetEncodedDealerBrandingZipFile = "GetEncodedDealerBrandingZipFile",
    LoadDealerBrandingImageList = "LoadDealerBrandingImageList",
    CreateDealerBrandingImage = "CreateDealerBrandingImage",
    DeleteDealerBrandingImage = "DeleteDealerBrandingImage",
    LoadDealerBrandingImage = "LoadDealerBrandingImage",
}
const category = "DealerBranding";

/**
 * DealerBranding image Payload
 */
export type ActionPayload = { image: DealerBranding } & ActionPayloadGeneric;

export type LoadActionPayload = {
    /**
     *Key used to locate and identify uploaded image
     *
     * @type {string}
     */
    key: string;
} & ActionPayloadGeneric;
export interface BulkActionResult {
    /**
     *Returns an array of DealerBranding image objects; subject to change
     *
     * @type {DealerBranding[]}
     * @memberof BulkActionResult
     */
    images: DealerBranding[];
}
export interface ActionResult {
    /**
     *Returns a DealerBranding image object
     *
     * @type {DealerBranding}
     * @memberof ActionResult
     */
    dealerBranding: DealerBranding;
}

export type DealerBrandingActions = ActionPayload & TypedAction<string>;

export const {
    load: loadSet,
    loadSingle: loadSingle,
    create: createSet,
} = createCrudActionSets<ActionPayload, LoadActionPayload, ActionResult, BulkActionResult>(category);

export const clearDealerBrandingState = createNoPropsAction(category, "Clear DealerBranding State");
export const clearDealerBrandingImageListState = createNoPropsAction(category, "Clear DealerBrandingImageList State");

export class GetDealerBrandingZipFileDownload implements Action {
    readonly type = ActionTypes.DealerBrandingZipFileDownload;
    constructor(public readonly payload: { zipData: { [key: string]: string }; callback: EventEmitter<File> }) {}
}

export class GetEncodedDealerBrandingZipFile implements Action {
    readonly type = ActionTypes.GetEncodedDealerBrandingZipFile;
    constructor(public readonly payload: { zipData: { [key: string]: string }; callback: EventEmitter<File> }) {}
}

export type DealerBrandingActionPayload = { entityId: number; fileName?: string; body?: Blob; key?: string } & ActionPayloadGeneric;

export const LoadDealerBrandingImageListActions = createActionSet<{ entityId: number }, { images: DealerBrandingListItem[] }>(
    category,
    ActionTypes.LoadDealerBrandingImageList
);

export const CreateDealerBrandingImageActions = createActionSet<DealerBrandingActionPayload>(
    category,
    ActionTypes.CreateDealerBrandingImage
);

export const DeleteDealerBrandingImageActions = createActionSet<DealerBrandingActionPayload, { key: string }>(
    category,
    ActionTypes.DeleteDealerBrandingImage
);

export const { confirm: deleteDealerBrandingImageConfirmation, dismiss: deleteDealerBrandingImageConfirmationDismiss } =
    createDeletePromptActionSet<DealerBrandingActionPayload>(category);

export const LoadDealerBrandingImageActions = createActionSet<DealerBrandingActionPayload, { dealerBranding: DealerBranding }>(
    category,
    ActionTypes.LoadDealerBrandingImage
);

export type Actions = GetDealerBrandingZipFileDownload | GetEncodedDealerBrandingZipFile;
